module.exports = __webpack_public_path__ + "img/rtp.2641d8ad.png";